import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "q-list-group q-w-100" }
const _hoisted_2 = { class: "q-list-group-item q-py-1 q-px-2" }
const _hoisted_3 = ["data-field", "value", "onChange", "checked"]
const _hoisted_4 = { class: "serp__filter--label q-mx-2" }
const _hoisted_5 = { class: "serp__filter--count q-figure-caption" }


import {useFiltersStore} from "@/store/SerpPage/FiltersStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxItem',
  props: ['filterDataValues', 'field'],
  emits: ['closeDropdown'],
  setup(__props, { emit: __emit }) {

const filtersStore = useFiltersStore();
const emit = __emit;



function updateFilter(field: string, label: string) {
  filtersStore.updateFilter(field, label);
  emit('closeDropdown');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filterDataValues, (filterData) => {
    return (_openBlock(), _createElementBlock("li", {
      class: "serp__filter--checkbox q-px-0 q-d-flex q-align-items-center",
      key: filterData.label
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, [
          _createElementVNode("input", {
            class: "serp__filter--checkbox-input q-form-check-input q-me-1",
            type: "checkbox",
            "data-field": __props.field,
            value: filterData.label,
            onChange: ($event: any) => (updateFilter(__props.field, filterData.label)),
            checked: _unref(filtersStore).filterIsChecked(__props.field, filterData.label)
          }, null, 40, _hoisted_3),
          _createElementVNode("span", _hoisted_4, _toDisplayString(filterData.label), 1),
          _createElementVNode("span", _hoisted_5, "(" + _toDisplayString(filterData.count) + ")", 1)
        ])
      ])
    ]))
  }), 128))
}
}

})